import { render } from "./SixthCut.vue?vue&type=template&id=4f98ec9c&scoped=true"
import script from "./SixthCut.vue?vue&type=script&lang=js"
export * from "./SixthCut.vue?vue&type=script&lang=js"

import "./SixthCut.vue?vue&type=style&index=0&id=4f98ec9c&lang=sass&scoped=true"

import exportComponent from "/Users/liyunchen/Documents/Salute Project/BMW_4GC/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f98ec9c"]])

export default __exports__